export const REQUEST_ERROR = Symbol('REQUEST_ERROR');

export const SINGLE_API = Symbol('SINGLE_API');
export const GET_PDF = Symbol('GET_PDF');
export const OPEN_PDF = Symbol('OPEN_PDF');
